module.exports = __webpack_public_path__ + "img/kkb_plugbox_powercon.2cd781c7.jpg";